import apiCompetitiveActivity from '@/api/competitive-activity'

const state = {
  isSubmitting: false,
  validationErrors: null,
}

export const mutationTypes = {
  competitiveActivityDeleteStart:
    '[competitive activity delete] competitiveActivity delete Start',
  competitiveActivityDeleteSuccess:
    '[competitive activity delete] competitiveActivity delete Success',
  competitiveActivityDeleteFailure:
    '[competitive activity delete] competitiveActivity delete Failure',
}

export const actionType = {
  competitiveActivityDelete:
    '[competitive activity delete] competitiveActivity delete',
}

const mutations = {
  [mutationTypes.competitiveActivityDeleteStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
  },

  [mutationTypes.competitiveActivityDeleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.competitiveActivityDeleteFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.competitiveActivityDelete](context, type_id) {
    context.commit(mutationTypes.competitiveActivityDeleteStart)
    return new Promise((resolve) => {
      apiCompetitiveActivity
        .deleteCompetitiveActivityList(type_id)
        .then((response) => {
          context.commit(
            mutationTypes.competitiveActivityDeleteSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.competitiveActivityDeleteFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
